import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_BOOKING, BOOKING_ERROR, CANCEL_BOOKING, DELETE_BOOKING, GET_BOOKINGS, GET_MY_BOOKING } from './types';

// Get bookings
export const getBookings = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/bookings`, config);

        dispatch({
            type: GET_BOOKINGS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: BOOKING_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Get my bookings
export const getMyBooking = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/bookings/me`, config);
        dispatch({
            type: GET_MY_BOOKING,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: BOOKING_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Add booking
export const addBooking = (formData, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.post(`${url}/api/bookings/bookroom`, formData, config);

        dispatch({
            type: ADD_BOOKING,
            payload: res.data
        });

        dispatch(setAlert('Added a new booking. Go to Bookings.', 'success'));
        navigate('/bookings');
    } catch (err) {
        dispatch(setAlert('This booking number already exists', 'danger'));
        dispatch({
            type: BOOKING_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
        
    }
}

// Cancel booking
export const cancelBooking = (_id, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about deleting this booking? This can NOT be undone!')) {
        try {
            const res = await axios.put(`${url}/api/bookings/cancel/${_id}`, config);

            dispatch({
                type: CANCEL_BOOKING,
                payload: {_id, status: res.data.status}
            });
            dispatch(setAlert('Cancelled a booking.', 'success'));
            //navigate('/bookings');
        } catch (err) {
            dispatch(setAlert('Cancelling Error. Try again.', 'danger'));
            dispatch({
                type: BOOKING_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
}

// Delete Booking
export const deleteBooking = (_id, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about deleting this booking? This can NOT be undone!')) {
        try {
            await axios.delete(`${url}/api/bookings/${_id}`, config);

            dispatch({
                type: DELETE_BOOKING,
                payload: _id
            });
            navigate('/bookings');
            dispatch(setAlert('Booking Deleted', 'success'));
        } catch (err) {
            dispatch({
                type: BOOKING_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
};
